const ValidationActions = {
  VALIDATION_STATE_SHOW: 'VALIDATION_STATE_SHOW',
  VALIDATION_RESET: 'VALIDATION_RESET'
};

/**
 * This function should changes all current page ValidationErrors in state to have the shouldDisplay flag.
 * This must be hard wired into apps as it is not used by default.

 * @returns [{type: string, shouldDisplay: true, local: boolean}]
 */
const showValidationErrors = () => {
  return async (dispatch) => {

    dispatch({
      type: ValidationActions.VALIDATION_STATE_SHOW,
      local: true,
      shouldDisplay: true,
    });
  };
};

const resetValidationErrors = () => {
  return async dispatch => dispatch({ type: ValidationActions.VALIDATION_RESET });
};

export {
  resetValidationErrors,
  showValidationErrors,
  ValidationActions
};
